// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"fK-z","carouselContainer":"gK-z"};